import React from "react";
import { Home, Building2, Factory, AlertTriangle, Cpu, ShieldAlert, ArrowUpRight } from "lucide-react";

const services = [
  {
    icon: Home,
    title: "Lakossági",
    desc: "Konnektor, kapcsoló, lámpa, falba húzás, FI relé csere — minden, ami egy lakásban előfordul.",
    code: "01",
    span: "md:col-span-4",
  },
  {
    icon: Building2,
    title: "Családi ház",
    desc: "Új építés, felújítás, hálózat teljes kiépítése. Mérőhely, almérők, kerti világítás.",
    code: "02",
    span: "md:col-span-4",
  },
  {
    icon: Cpu,
    title: "Okosotthon",
    desc: "KNX, Shelly, Loxone, Apple Home, Google Home. Okosrelé, redőny, fűtésvezérlés.",
    code: "03",
    span: "md:col-span-4",
  },
  {
    icon: Factory,
    title: "Ipari villanyszerelés",
    desc: "Üzemcsarnok, raktár, gépbekötés, motorvezérlés, 400V hálózat, karbantartás. Műszakos elérhetőség.",
    code: "04",
    span: "md:col-span-7",
    highlight: true,
    image:
      "https://images.pexels.com/photos/28265032/pexels-photo-28265032.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    icon: ShieldAlert,
    title: "Villámvédelem",
    desc: "Túlfeszültség elleni védelem, földelés mérés, MSZ szabványos kivitelezés, jegyzőkönyv.",
    code: "05",
    span: "md:col-span-5",
  },
];

export default function Services() {
  return (
    <section id="szolgaltatasok" data-testid="services-section" className="border-b border-[#262626]">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16 md:py-24">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-12">
          <div>
            <div className="font-mono text-xs text-[#FFD700] uppercase tracking-[0.4em] mb-3">
              [ 01 / Szolgáltatások ]
            </div>
            <h2 className="font-heading uppercase text-4xl md:text-6xl leading-none">
              Bármi, ami<br />
              <span className="text-[#FFD700]">áram alatt áll.</span>
            </h2>
          </div>
          <p className="max-w-md text-[#A3A3A3]">
            Egyszemélyes szerelés helyett valódi csapat. Saját autóval, raktárkészlettel, mérőműszerekkel.
            Mindent egy kézből.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-5">
          {services.map((s) => {
            const Icon = s.icon;
            return (
              <div
                key={s.code}
                data-testid={`service-${s.code}`}
                className={`${s.span} ${s.highlight ? "card-hi" : "card"} relative overflow-hidden group`}
              >
                {s.image && (
                  <div
                    className="absolute inset-0 opacity-20 group-hover:opacity-30 transition-opacity"
                    style={{
                      backgroundImage: `url(${s.image})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      filter: "grayscale(100%) contrast(120%)",
                    }}
                  />
                )}
                <div className="relative">
                  <div className="flex items-start justify-between mb-6">
                    <div className="w-12 h-12 bg-[#FFD700] flex items-center justify-center">
                      <Icon className="w-6 h-6 text-black" strokeWidth={2.5} />
                    </div>
                    <span className="font-mono text-xs text-[#A3A3A3]">{s.code}</span>
                  </div>
                  <h3 className="font-heading uppercase text-2xl md:text-3xl mb-3 leading-tight">
                    {s.title}
                  </h3>
                  <p className="text-[#A3A3A3] leading-relaxed">{s.desc}</p>
                  <div className="mt-6 inline-flex items-center gap-1 font-mono text-xs uppercase tracking-widest text-[#FFD700]">
                    Részletek <ArrowUpRight className="w-3 h-3" />
                  </div>
                </div>
              </div>
            );
          })}

          {/* Emergency banner card */}
          <div
            data-testid="emergency-banner"
            className="md:col-span-12 bg-[#FFD700] text-black p-8 md:p-10 border-4 border-black flex flex-col md:flex-row md:items-center md:justify-between gap-4"
          >
            <div className="flex items-center gap-4">
              <AlertTriangle className="w-10 h-10 md:w-14 md:h-14" strokeWidth={2.5} />
              <div>
                <div className="font-heading uppercase text-2xl md:text-4xl leading-none">
                  0-24 hibaelhárítás
                </div>
                <div className="font-mono text-sm md:text-base mt-1">
                  Áramszünet, zárlat, füst, szikra? Hívj most.
                </div>
              </div>
            </div>
            <a
              href="tel:+36204565627"
              data-testid="emergency-call-btn"
              className="bg-black text-[#FFD700] font-heading uppercase tracking-wider px-6 py-4 border-2 border-black hover:bg-[#1a1a1a] transition-colors text-lg whitespace-nowrap"
            >
              +36 20 456 5627
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
